import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const headers = new HttpHeaders().set(
  'Ocp-Apim-Subscription-Key',
  environment.ocpApimSubscriptionValue
);

@Injectable({
  providedIn: 'root',
})
export class B2cService {
  newAccessToken!: any;
  private httpClient: HttpClient;
  constructor(private httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
  }

  getAccessToken(): Observable<any> {
    return this.httpClient.get(environment.idpUserAdminAPI + '/b2cToken', {
      headers: headers,
    });
  }
}
